function checkAnonymousCheckbox($elem) {
    if ($elem.prop('checked')) {
        $('.js-hotline-email').find('.js-input').removeAttr('data-required').removeClass('_error');
        $('.js-person-type-info').find('.js-input').removeAttr('data-required').removeClass('_error');
        $('.js-hotline-phone').find('.js-input').removeAttr('data-required').removeClass('_error');
        $('.js-person-fio-ur').find('.js-input').removeAttr('data-required').removeClass('_error');
        $('.js-hotline-email-note').removeClass('_hidden');
        return;
    }

    $('.js-hotline-email').find('.js-input').attr('data-required', true);
    $('.js-hotline-email-note').addClass('_hidden');
}
$('.js-hotline-email-check').on('change', (e) => checkAnonymousCheckbox($(e.target)));

App.H.on('click', '.js-ticket-more', function() {
    $(this).addClass('_hidden');
    $('.js-ticket-text').addClass('_shown');
});

let hotlineDates;
if ($('.js-hotline-date').length) {
    hotlineDatepicker();
}
$('.js-hotline-dates').on('click', function() {
    $('.js-hotline-calendar').addClass('_shown');
});
$('.js-hotline-period').on('click', function() {
    $('.js-hotline-period').removeClass('_active');
    $(this).addClass('_active');
    $('.js-hotline-date').datepicker( "destroy" );
    hotlineDatepicker();
});
$('.js-hotline-calendar-close').on('click', function() {
    $('.js-hotline-calendar').removeClass('_shown');
});
$('.js-hotline-calendar-apply').on('click', function() {
    $('.js-hotline-dates').val(hotlineDates);
    $('.js-hotline-calendar').removeClass('_shown');
});

function hotlineDatepicker() {
    if ($('.js-one-day').hasClass('_active')) {
        $('.js-hotline-date').datepicker({
            dateFormat: "dd.mm.yy",
            maxDate: 0,
            onSelect: function(selectedDate) {
                hotlineDates = selectedDate;
            },
        });
    }
    if ($('.js-period').hasClass('_active')) {
        $('.js-hotline-date').datepicker({
            range: 'period', // режим - выбор периода
            dateFormat: "dd.mm.yy",
            onSelect: function(dateText, inst, extensionRange) {
                hotlineDates = extensionRange.startDateText + ' - ' + extensionRange.endDateText;
            },
        });
    }
}

function checkManagementKnows($elem) {
    $('.js-management-knows-info').addClass('_hidden');

    if ($elem.find('option:selected').hasClass('js-management-knows-yes')) {
        $('.js-management-knows-info').removeClass('_hidden');
    }
}
$('.js-management-knows').on('change', (e) => checkManagementKnows($(e.target)));

function checkPersonType($elem) {
    const personType = $elem.find('option:selected').attr('data-person-type');

    $('.js-person-type-info').addClass('_hidden');
    $(`.js-person-type-${personType}`).removeClass('_hidden');

    if (personType === "ur") {
        $('.js-hotline-phone').addClass('_hidden');
        $('.js-person-fio-ur').removeClass('_hidden');
    } else {
        $('.js-hotline-phone').removeClass('_hidden');
        $('.js-person-fio-ur').addClass('_hidden');
    }
}
$('.js-person-type').on('change', (e) => checkPersonType($(e.target)));

export function checkHotline() {
    const $anonymousCheckbox = $('.js-hotline-email-check');
    const $managementKnowsSelect = $('.js-management-knows');
    const $personTypeSelect = $('.js-person-type');

    if ($anonymousCheckbox.length) {
        checkAnonymousCheckbox($anonymousCheckbox);
    }

    if ($managementKnowsSelect.length) {
        checkManagementKnows($managementKnowsSelect);
    }

    if ($personTypeSelect.length) {
        checkPersonType($personTypeSelect);
    }
}



// WEBPACK FOOTER //
// ./_src/js/Hotline.js